import getIdTokenCookie from './cookies/getIdTokenCookie';

// CheggUser type containing information parsed from id_token

export var getUserUuid = function getUserUuid(idToken) {
  var _isoParseIdTokenJWT;
  var jwt = getIdTokenCookie() || idToken;
  if (!jwt) {
    return undefined;
  }
  return (_isoParseIdTokenJWT = isoParseIdTokenJWT(jwt)) === null || _isoParseIdTokenJWT === void 0 ? void 0 : _isoParseIdTokenJWT.sub;
};
export function isoParseIdTokenJWT(token) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    if (typeof window !== 'undefined') return JSON.parse(window.atob(base64));
    return JSON.parse(Buffer.from(base64, 'base64').toString());
  } catch (_unused) {
    return undefined;
  }
}